import axios from '../axios';

// 操作日志列表
export const getSysLogPage = data => {
return axios({
url: '/api/sys/sys/getSysLogPage',
method: 'post',
data
})
};

// 操作日志保存
export const saveSysLog = data => {
return axios({
url: '/api/sys/sys/saveSysLog',
method: 'post',
data
})
};

// 操作日志修改
export const updateSysLog = data => {
return axios({
url: '/api/sys/sys/updateSysLog',
method: 'post',
data
})
};

// 操作日志删除
export const deleteSysLog = data => {
return axios({
url: '/api/sys/deleteSysLog',
method: 'post',
data
})
};

// 操作日志查单条
export const getSysLog = data => {
return axios({
url: '/api/sys/getSysLog',
method: 'post',
data
})
};
// 菜单操作日志列表
export const getSysLogFormPage = data => {
    return axios({
    url: '/api/sys/sys/getSysLogFormPage',
    method: 'post',
    data
    })
};
// 菜单操作日志列表 保存
export const saveSysLogForm = data => {
    return axios({
    url: '/api/sys/sys/saveSysLogForm',
    method: 'post',
    data
    })
};
// 菜单操作日志列表 修改
export const updateSysLogForm = data => {
    return axios({
    url: '/api/sys/sys/updateSysLogForm',
    method: 'post',
    data
    })
};
// 菜单操作日志列表 删除
export const deleteSysLogForms = data => {
    return axios({
    url: '/api/sys/sys/deleteSysLogForms',
    method: 'post',
    data
    })
};
// 查询操作日志是登陆的
export const getSysLogPageOfLogin = data => {
    return axios({
    url: '/api/sys/sys/getSysLogPageOfLogin',
    method: 'post',
    data
    })
};




// WEBPACK FOOTER //
// ./src/api/moudules/SysLogApi.js